export default __webpack_public_path__ + "static/media/login-design.c9842321.png";